var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import localize from "@/utils/localization";
import { wait } from "@/utils/utils";
import { computed, ref, onMounted, watchEffect } from "vue";
import { BAlert, BCard, BCardText, BLink } from "bootstrap-vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CleanupOperationSummary',
    props: {
        operation: null,
        refreshOperationId: { default: undefined },
        refreshDelay: { default: 500 }
    },
    emits: ["onReviewItems"],
    setup(__props, { emit }) {
        const props = __props;
        const summary = ref();
        const loading = ref(true);
        const errorMessage = ref();
        const canClearItems = computed(() => {
            var _a, _b;
            return ((_b = (_a = summary.value) === null || _a === void 0 ? void 0 : _a.totalItems) !== null && _b !== void 0 ? _b : 0) > 0;
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield refresh();
        }));
        watchEffect(() => __awaiter(this, void 0, void 0, function* () {
            if (props.operation.id === props.refreshOperationId) {
                yield refresh();
            }
        }));
        function refresh() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const start = Date.now();
                    summary.value = yield props.operation.fetchSummary();
                    const duration = Date.now() - start;
                    yield wait(props.refreshDelay - duration);
                }
                catch (error) {
                    onError(String(error));
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function onError(message) {
            errorMessage.value = message;
        }
        function onReviewItems() {
            var _a, _b;
            emit("onReviewItems", props.operation, (_b = (_a = summary.value) === null || _a === void 0 ? void 0 : _a.totalItems) !== null && _b !== void 0 ? _b : 0);
        }
        return { __sfc: true, props, summary, loading, errorMessage, canClearItems, emit, refresh, onError, onReviewItems, localize, BAlert, BCard, BCardText, BLink, LoadingSpan };
    }
});
